import React from 'react';
import styled from 'styled-components';
import { COMMON } from './constants';
import sx from './sx';

function Octicon({
  icon: IconComponent,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(IconComponent, rest);
}

Octicon.displayName = "Octicon";
const StyledOcticon = styled(Octicon).withConfig({
  displayName: "StyledOcticon",
  componentId: "uhnt7w-0"
})(["", " ", ""], COMMON, sx);
StyledOcticon.defaultProps = {
  size: 16
};
export default StyledOcticon;